import React from 'react';

const Skillsoft = () => {
  return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
            <g id="Group_2475988" data-name="Group 2475988" transform="translate(6962 -640)">
                <rect id="Rectangle_450083" data-name="Rectangle 450083" width="22" height="22" transform="translate(-6962 640)" fill="none"/>
                <g id="skillsoft-paper-logo-2026" transform="translate(-7071 514.014)">
                <path id="Path_2500886" data-name="Path 2500886" d="M127,134.145c-2.619,0-4.129,1.381-6.614,3.891-2.375,2.41-5.748,5.95-11.386,5.95v-8.159c2.619,0,4.128-1.381,6.614-3.891,2.375-2.41,5.748-5.95,11.386-5.95Z" transform="translate(2 2)"/>
                </g>
            </g>
        </svg>

    </>
  )
};

export default Skillsoft;
